import { useRef, useEffect, useState } from "react";
import { UPDATE_COMPARISON_SIMULATIONS } from "../../../data/queries";
import { useModelsMutation } from "apps/platform-client/client/src/hooks/useModelsModule";

let globalTimeout: NodeJS.Timeout | null = null;

export function useDebouncedSimulationComparisonUpdate() {
	const [updateSimulations, { error }] = useModelsMutation(UPDATE_COMPARISON_SIMULATIONS);
	const [simulationErrorId, setSimulationErrorId] = useState<string | null>(null);
	const [isRemoveComparison, setIsRemoveComparison] = useState<boolean>(false);

	const contextRef = useRef<{
		simulationId: string;
		previousSimulations: string[];
	} | null>(null);

	const triggerUpdate = (simulationId: string, newSimulations: string[], isRemoving: boolean) => {
		if (globalTimeout) {
			clearTimeout(globalTimeout);
		}

		contextRef.current = {
			simulationId,
			previousSimulations: [...newSimulations],
		};

		setIsRemoveComparison(isRemoving);

		globalTimeout = setTimeout(() => {
			updateSimulations({
				variables: { req: JSON.stringify(newSimulations) },
			});
		}, 250);
	};

	useEffect(() => {
		if (error && contextRef.current) {
			setSimulationErrorId(contextRef.current.simulationId);
			console.error("Simulation comparison error:", error);
		}
	}, [error]);

	useEffect(() => {
		return () => {
			if (globalTimeout) {
				clearTimeout(globalTimeout);
			}
		};
	}, []);

	return {
		triggerUpdate,
		simulationErrorId,
		setSimulationErrorId,
		isRemoveComparison,
	};
}
